module.exports = __webpack_public_path__ + "img/thumb_38.a6a6b00f.jpg";